// extracted by mini-css-extract-plugin
export var body = "_ln-0";
export var sectionHeader = "_ln-4";
export var shortcutColumns = "_ln-2";
export var shortcutList = "_ln-1";
export var shortcutSection = "_ln-3";